export default {
  namespaced: true,
  state: {
    items: [],
    types: [{
        value: "external-maintenance-certificate",
        text: "Certificat contrôle obligatoire"
      },
      {
        value: "temporary-external-maintenance-certificate",
        text: "Certificat temporaire"
      },
      {
        value: "external-maintenance-attachment",
        text: "Fichier joint"
      },
      {
        value: "purchase_order",
        text: "Bon de commande SAP"
      },
      {
        value: "invoice",
        text: "Facture"
      },
      {
        value: "complaint-attachment",
        text: "Fichier joint à la réclamation"
      }
    ]
  },
  getters: {
    getTypes: state => state.types,
    getType: state => type => state.types.find(item => item.value == type)
  },
  actions: {

    /**
     * Cette fonction est vide mais nécessaire car appelée automatiquement par le store parent. Sinon ça génère une erreur
     */
    getAll: (context, wait = false) => {

    },
    addItem(context, item) {
      let formData = new FormData();
      for (var index in item) {
        if (item[index]) {
          formData.append(index, item[index]);
        }
      }

      let params = {
        api_url: 'storedfile',
        namespace: 'stored_file',
        item: item,
        formData: formData,
        ignoreGetAll: true
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'storedfile',
        namespace: 'stored_file',
        id: id,
        ignoreGetAll: true
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/stored_file.js